import React from "react";
import ReactDOM from "react-dom";
import App from "App";
import "./index.scss";
import { applyForcedLang } from "config/forcedLang";

applyForcedLang();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
